import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import Messages from './messages';
import CommentIcon from 'material-ui/svg-icons/communication/comment';
import {
  initialLoadAMsg as initialLoadAMsgAction,
} from '../messagingStore/messaging-actions';
import R from 'ramda';

const propTypes = {
  channelId: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
  initialLoadAMsg: PropTypes.func,
  loadingMessages: PropTypes.bool,
  messages: PropTypes.array,
  messagesLoaded: PropTypes.bool,
  params: PropTypes.object,
};

const styles = {
  title: {
    color: 'white',
    fontSize: '18px',
    flex: '1 0 auto',
    lineHeight: '48px',
    paddingLeft: '10px',
    backgroundColor: 'rgb(0, 164, 186)',
    height: '48px !important',
  },
};

class RightMsgsRouter extends React.Component {
  componentWillMount() {
    const { params, initialLoadAMsg } = this.props;
    const convIdFromUrl = (params || {}).channelId;
    // const convIdFromUrl = (params || {}).convId;
    if (convIdFromUrl) initialLoadAMsg(convIdFromUrl);
  }
  componentWillReceiveProps(nextProps) {
    const currentChannelIdFromParams = R.path(['params', 'channelId'], this.props);
    const nextChannelIdFromParams = R.path(['params', 'channelId'], nextProps);
    if (currentChannelIdFromParams && currentChannelIdFromParams !== nextChannelIdFromParams && nextChannelIdFromParams) {
      this.props.initialLoadAMsg(nextChannelIdFromParams);
    }
    if (!currentChannelIdFromParams && nextProps.channelId) {
      this.context.router.push(`/workspace/inbox/${nextProps.channelId}`);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== React.PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const { messagesLoaded, className, classes, messages } = this.props;
    return (
      <div className={`l-left-nav-content ${className}`} style={{ width: 'calc(100% - 628px)', overflowY: 'scroll' }}>
        {(messages.length > 0) ? <div className={classes.title}>{messages[0].subject || ''}</div> : undefined}
        {messages.length < 1 && !messagesLoaded ? (
          <div style={{ textAlign: 'center', marginTop: '200px' }}>
            <CommentIcon style={{ color: 'rgba(0, 0, 0, 0.24)', height: '56px', width: '56px' }} />
          </div>
        ) : <Messages {...this.props} />}
      </div>
    );
  }
}

RightMsgsRouter.propTypes = propTypes;

const mapStateToProps = ({ messaging }) => ({
  loadingMessages: messaging.messages.get('loadingMessages'),
  messagesLoaded: messaging.messages.get('messagesLoaded'),
  channelId: messaging.messages.getIn(['conv', '_id']),
  messages: messaging.messages.toJS().list,
});
const mapDispatchToProps = dispatch => ({
  initialLoadAMsg: (...args) => dispatch(initialLoadAMsgAction(...args)),
});
RightMsgsRouter.contextTypes = {
  router: PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(RightMsgsRouter));



// WEBPACK FOOTER //
// ./src/app/components/messaging/singleConv/rgtMsgsRouter.jsx